/**
 * State threaded through `history.push`/`history.replace` across the public
 * registration flow (CM-168) instead of a global store — see CM-616's notes on
 * why: refreshing the page naturally clears `location.state`, which is exactly
 * the "refresh restarts the wizard" behaviour CM-617 specifies for its guard.
 */
export interface DeviceRegistrationLocationState {
  serial: string;
  pin: string;
  description: string;
  confirmChecked?: boolean;
}

export const isValidDeviceRegistrationState = (
  state: DeviceRegistrationLocationState | undefined
): state is DeviceRegistrationLocationState => !!state && !!state.serial && !!state.pin;
